import ServiceExec from '@/common/utils/ServiceExec';
import { forEach } from 'lodash';

class PaySvc extends ServiceExec {
  /**
   *  결제 요청 정보 생성
   *  @param Authorization {string} Authorization
   *  @param expertPayDTO {ExpertPayDTO} expertPayDTO
   */
  postIntPayTemp(params = {}) {
    return this.post(`/api/expert/payment-init`, params).then((response) => {
      return response.data;
    });
    // return this.post(`/api/expert/pay/postIntPayTemp`, params).then(
    //   (response) => {
    //     return response.data
    //   }
    // )
  }
  /**
   *  결제 요청 실패 or 취소
   *  @param payNo {integer} payNo
   *  @param reason {string} reason
   *  @param status {integer} status
   */
  patchIntPayTempStatus(params = {}) {
    const formData = new FormData();
    forEach(params, function (value, key) {
      formData.append(key, value);
    });
    return this.patch(`/api/expert/pay/patchIntPayTempStatus`, formData).then((response) => {
      return response.data;
    });
  }

  /**
   *  티켓 가격 및 정보 호출
   *  @param types {integer} types
   */
  getListTicketInfo(params = {}) {
    return this.get(`/api/expert/pay/getListTicketInfo`, params).then((response) => {
      return response.data;
    });
  }
}

export default new PaySvc();
